import React from 'react'
import PropTypes from 'prop-types';
import styled from 'styled-components'
import {Link} from 'react-router-dom'
import Color from 'constants/colors'
import FlagContent from 'components/interactive/flag-content'
import ShareToggle from 'pages/user/shareToggle'
import AnnotationToggle from './ShowAnnotationsToggle'
import PrivacyModal from './PrivacyModal'

const ControlsContainer = styled.div`
  text-align: left;
`;

const StyledLink = styled(Link)`
  display: block;
  font-family: ${props=>props.theme.fonts.h4};
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;
`;

const StyledDiv = styled.div`
  font-family: ${props=>props.theme.fonts.h4};
  color: ${Color('purple')};
  font-size: 12px;
  cursor: pointer;
`;

const Label = styled.div`
  margin-top:10px;
  font-family: ${props=>props.theme.fonts.h4};
  font-size: 14px;
  display: inline-block;
`;

const UrlStyle = styled.div`
  padding: 20px 20px;
  background-color: #eee;
  color: #333;
  border-radius: 1px;
  border: 2px solid black;
  user-select: text;
`;

const VotePrefControls = (props) => {
  const {
    pageId,
    authorUserId, loggedInUserId, shared
  } = props.data;
  const host = `${window.location.origin}`;
  const resourceUrl = `${host}/election/${pageId}/${loggedInUserId}`;

  // display share url if we're shared
  let ShareUrl = null;
  if (shared) {
    ShareUrl = (
      <Label>
        Share this link:<br/> 
        <UrlStyle>{resourceUrl}</UrlStyle>
      </Label>
    );
  }

  const PrivacyToggle = 
    <ShareToggle 
      userId={authorUserId} 
      pageId={pageId} 
      shared={shared} 
      verbose
    />

  const PrivacyControl = 
    <PrivacyModal isShared={shared}>
      {PrivacyToggle}
      {ShareUrl}
    </PrivacyModal>

  const AboutThis =
  	<StyledLink to="/election/personalized-guide">
  		 About My Voter Guides
		</StyledLink>;

  const ShowAnnosToggle = 
    <StyledDiv>
      <AnnotationToggle />
    </StyledDiv>

  const SeeMyPage =
    <React.Fragment>
      <Label>
        You're viewing someone else's Voter Guide
      </Label>
      <StyledLink to={`/election/${pageId}`}>
        See my own notes for this page
      </StyledLink>
    </React.Fragment>

 	const Flag =
    <StyledDiv>
      <FlagContent resource={resourceUrl} text="Report this" />
    </StyledDiv>


  const loggedInButOnSomebodyElsesPage = (authorUserId && loggedInUserId && (authorUserId !== loggedInUserId));
  const loggedInAndNotOnSomebodysPage = (loggedInUserId && !loggedInButOnSomebodyElsesPage);
  return(
    <ControlsContainer>
      { loggedInAndNotOnSomebodysPage && PrivacyControl }
      { loggedInButOnSomebodyElsesPage && SeeMyPage }
      { AboutThis }
      { ShowAnnosToggle }
      { Flag }
    </ControlsContainer>
	)
}

VotePrefControls.propTypes = {
  data: PropTypes.shape({
    // required data
    onToggleEdit: PropTypes.func.isRequired,
    shared: PropTypes.bool, //had to make not required

    viewerIsOwner: PropTypes.bool,

    // optional data
    authorUserId: PropTypes.string,
    loggedInUserId: PropTypes.string,
    pageId: PropTypes.string,

  }).isRequired
};

export default VotePrefControls;




// WEBPACK FOOTER //
// ./src/components/interactive/votePref/VotePrefControls.js